var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('way-el-form',{ref:"queryForm",attrs:{"model":"form","inlineBlock":_vm.inlineBlock,"formProps":_vm.formProps,"form":_vm.originData,"enableSpin":_vm.spin,"action":['submit', 'reset'],"actionProps":_vm.actionProps,"showFooter":_vm.showFooter},on:{"submit":_vm.handleSubmit,"reset":_vm.handleReset}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }